// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductFooterForm_container__636_C","footerActions":"ProductFooterForm_footerActions__yFYLd","quantityChange":"ProductFooterForm_quantityChange__1Udu_"};